import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "surveys" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "switch-label" }, "Toon gesloten keuringen:", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }

import { computed, onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { ls } from '@/ls'
import Column from '@/types/column'
import TableSettings from '@/types/tableSettings'
import axios from 'axios'
import { surveyStore } from '@/stores/survey'
import PageTitleBar from '@/components/PageTitleBar.vue'
import { SurveyTypes, SurveyStateLabels, SurveyStateLabelColors } from '@/helpers/surveyStates'
import ColumnSettings from '@/components/ColumnSettings.vue'
import { authStore } from '@/stores/auth'
import FilterBox from '@/components/FilterBox.vue'
import { can } from '@/globalFunctions'


export default /*#__PURE__*/_defineComponent({
  __name: 'Surveys',
  setup(__props) {

const router = useRouter()

const tableSettings = ref<TableSettings>(ls.get('SurveysTableSettings') || {
  pagination: { current: 1, pageSize: 25 },
  showSizeChanger: true,
  pageSizeOptions: ['25', '50', '100'],
  activeFilters: null,
  sort: null,
  search: null,
  archived: false
})

const columns = ref([
  {
    title: '#',
    key: 'id',
    sorter: true
  },
  {
    title: 'Type',
    key: 'survey_form.type',
    filters: [
      {
        text: 'Controle',
        value: 1
      },
      {
        text: 'Inspectie',
        value: 2
      },
      {
        text: 'Keuring',
        value: 3
      },
      {
        text: 'Bewijslast',
        value: 5
      },
      {
        text: 'Keuringsdocument',
        value: 7
      },
      {
        text: 'Externe inspectie',
        value: 9
      },
      {
        text: 'Interne inspectie',
        value: 10
      }
    ]
  },
  {
    title: 'Formulier',
    key: 'survey_form.id',
    sorter: false
  },
  {
    title: 'Project',
    key: 'project.id',
    filters: [],
    sorter: false
  },
  {
    title: 'Blok',
    key: 'building_block.name',
    sorter: false
  },
  {
    title: 'Bouwnummer',
    key: 'building.number',
    sorter: true
  },
  {
    title: 'Adres',
    key: 'building.address',
    sorter: false
  },
  {
    title: 'Toegewezen aan',
    key: 'scheduled_user.id',
    filters: []
  },
  {
    title: 'Uitvoeren op',
    key: 'scheduled_at',
    sorter: true
  },
  {
    title: 'Status',
    key: 'status',
    filters: []
  },
  {
    title: 'Resultaat',
    key: 'result'
  }
])

const statusFilters = computed(() => {
  return !tableSettings.value.archived ? [
    {
      text: 'Ingepland',
      value: 1
    },
    {
      text: 'Concept',
      value: 2
    }
  ] : [
    {
      text: 'Verlopen',
      value: 3
    },
    {
      text: 'Voltooid',
      value: 4
    }
  ]
})

const hiddenColumns = ref<string[]>([])
const filteredColumns = computed(() => {
  const filteredColumns = columns.value.filter(c => !hiddenColumns.value.includes(c.key))
  const indexOfStatus = filteredColumns.findIndex(obj => obj.key === 'status')
  if (indexOfStatus !== -1) filteredColumns[indexOfStatus].filters = statusFilters.value
  return filteredColumns
})

onMounted(() => {
  surveyStore().getSurveys(tableSettings.value)
  getFilters()
  onTableSettingsChange()
})

function getFilters () : void {
  getFormFilter()
  getProjectFilter()
  getAssignedToFilter()
}

function getFormFilter () : void {
  axios.post(process.env.VUE_APP_API_URL + '/filters/surveyForm/surveys', { textColumn: 'name', textColumn2: 'reference', textColumnSeperator: '-', valueColumn: 'id' }).then((r) => {
    columns.value[2].filters = r.data
  })
}

function getProjectFilter () : void {
  axios.post(process.env.VUE_APP_API_URL + '/filters/project/surveys', { textColumn: 'name', textColumn2: 'reference', valueColumn: 'id' }).then((r) => {
    columns.value[3].filters = r.data
  })
}

function getAssignedToFilter () : void {
  if (onlyExternalInspections.value) {
    columns.value[7].filters = [{ text: authStore().user.full_name, value: authStore().user.id }]
  } else {
    axios.post(process.env.VUE_APP_API_URL + '/filters/user/surveys', { textColumn: 'full_name', valueColumn: 'id' }).then((r) => {
      columns.value[7].filters = r.data
    })
  }
}

function onCustomRowClick (record:{ id:number, type:number }) : { onClick: () => void } {
  return {
    onClick: () => {
      router.push({ name: 'SurveyShow', params: { surveyId: record.id.toString() } })
    }
  }
}

function archivedChanged () : void {
  if (tableSettings.value.activeFilters?.status) {
    delete tableSettings.value.activeFilters.status
  }

  surveyStore().getSurveys(tableSettings.value)
}

watch(() => tableSettings, () => {
  onTableSettingsChange()
}, { deep: true })

function handleTableChange (pagination:{ current:number, pageSize:number }, filters:{[key: string]: number[]|string[]}, sort:{ columnKey:string, order:string }) : void {
  // Remove key from filters if filter is an empty object.
  if (filters && Object.keys(filters).length) {
    Object.keys(filters).forEach((key) => {
      if (!filters[key] || !filters[key].length) {
        delete filters[key]

        columns.value.forEach((column:Column) => {
          if (column.key === key) {
            column.filteredValue = null
          }
        })
      }
    })
  }

  // Set pagination, filters and sorting on tableSettings.
  tableSettings.value.pagination = pagination
  tableSettings.value.activeFilters = filters
  tableSettings.value.sort = sort.order ? sort : null

  // Get list based on filters and search term.
  surveyStore().getSurveys(tableSettings.value)
}

function handleSearchChange (searchTerm:string) : void {
  tableSettings.value.search = searchTerm

  // Set page to 1 because of new search but retain filters and sorting.
  tableSettings.value.pagination.current = 1

  // Get list based on filters and search term.
  surveyStore().getSurveys(tableSettings.value)
}

function onTableSettingsChange () : void {
  // On tableSettings change, store them in local storage.
  ls.set('SurveysTableSettings', tableSettings.value)

  axios.post(process.env.VUE_APP_API_URL + '/users/constructionSiteApp/settings', {
    settingName: 'SurveysTableSettings',
    settingValue: tableSettings.value
  })

  // Set the current active filters on the columns.
  columns.value.forEach((column:Column) => {
    // Set active filters.
    if (tableSettings.value.activeFilters && column.key in tableSettings.value.activeFilters) {
      column.filteredValue = tableSettings.value.activeFilters[column.key]
    } else {
      column.filteredValue = null
    }

    // Set active sort order.
    if (tableSettings.value.sort && column.key === tableSettings.value.sort.columnKey) {
      column.defaultSortOrder = tableSettings.value.sort.order
      column.sortOrder = tableSettings.value.sort.order
    } else {
      column.sortOrder = false
    }
  })
}

function updateFilters (activeFilters:{[key: string]: number[]|string[]}) : void {
  tableSettings.value.activeFilters = activeFilters
  surveyStore().getSurveys(tableSettings.value)
}

const pagination = computed(() => {
  return {
    current: tableSettings.value.pagination.current,
    defaultPageSize: tableSettings.value.pagination.pageSize,
    pageSize: parseInt(surveyStore().surveys.meta.per_page),
    total: surveyStore().surveys.meta.total,
    showTotal: (total:number, range:number[]) => `Keuring ${range[0]} t/m ${range[1]} van de ${total}`,
    showSizeChanger: tableSettings.value.showSizeChanger,
    pageSizeOptions: tableSettings.value.pageSizeOptions
  }
})

const onlyExternalInspections = computed(() => {
  return can('construction_site_portal.external_inspections.view') && !can('construction_site_portal.surveys.view')
})

return (_ctx: any,_cache: any) => {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageTitleBar, null, {
      title: _withCtx(() => [
        _createTextVNode("Keuringen.")
      ]),
      buttons: _withCtx(() => [
        _createVNode(ColumnSettings, {
          columns: columns.value,
          storageName: "hiddenSurveyColumns",
          onHiddenColumnsChanged: _cache[0] || (_cache[0] = ($event: any) => (hiddenColumns.value = $event))
        }, null, 8, ["columns"]),
        _createVNode(_component_a_switch, {
          checked: tableSettings.value.archived,
          "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((tableSettings.value.archived) = $event)),
          onChange: archivedChanged
        }, null, 8, ["checked"]),
        _createTextVNode(),
        _hoisted_2
      ]),
      search: _withCtx(() => [
        _createVNode(_component_a_input_search, {
          placeholder: "Zoeken..",
          style: {"width":"100%"},
          value: tableSettings.value.search,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((tableSettings.value.search) = $event)),
          onSearch: handleSearchChange,
          "enter-button": "",
          "allow-clear": ""
        }, null, 8, ["value"])
      ]),
      _: 1
    }),
    _createVNode(FilterBox, {
      view: "surveys",
      activeFilters: tableSettings.value.activeFilters,
      columns: columns.value,
      onUpdate: updateFilters
    }, null, 8, ["activeFilters", "columns"]),
    _createVNode(_component_a_table, {
      columns: _unref(filteredColumns),
      "data-source": _unref(surveyStore)().surveys.data,
      loading: _unref(surveyStore)().loading.list,
      rowKey: "id",
      customRow: onCustomRowClick,
      scroll: { x: true },
      pagination: _unref(pagination),
      onChange: handleTableChange
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.key === 'id')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(record.id), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'survey_form.type')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(record.type ? _unref(SurveyTypes)[record.type] : '-'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'survey_form.id')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(record.survey_form ? record.survey_form.reference + ' - ' + record.survey_form.name : '-'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'project.id')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(record.project ? record.project.name + ' (' + record.project.reference + ')' : '-'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'building_block.name')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              (record.project.configurator_version === 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(record.building_block ? record.building_block.name : '-'), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(record.building_group_block ? record.building_group_block.name : '-'), 1)
                  ], 64))
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'building.number')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              _createTextVNode(_toDisplayString(record.building ? record.building.number : '-'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'building.address')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
              (record.building)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    _createTextVNode(_toDisplayString(record.building.address) + ",", 1),
                    _hoisted_4,
                    _createTextVNode(_toDisplayString(record.building.zipcode) + " " + _toDisplayString(record.building.city), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, "-"))
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'scheduled_at')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
              _createTextVNode(_toDisplayString(record.scheduled_at ? new Date(record.scheduled_at).toLocaleDateString('nl-NL') : '-'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'scheduled_user.id')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
              _createTextVNode(_toDisplayString(record.scheduled_user ? record.scheduled_user.full_name : '-'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'status')
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 9,
              color: _unref(SurveyStateLabelColors)[record.status]
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(record.status ? _unref(SurveyStateLabels)[record.status] : '-'), 1)
              ]),
              _: 2
            }, 1032, ["color"]))
          : _createCommentVNode("", true),
        (column.key === 'result')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
              (record.result === 0)
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 0,
                    color: "red"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Afgekeurd")
                    ]),
                    _: 1
                  }))
                : (record.result === 1)
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 1,
                      color: "green"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Goedgekeurd")
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, "-"))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "data-source", "loading", "pagination"])
  ]))
}
}

})